import { PAGE_LAYOUT_PAGES } from '../page-layouts/manifest.js';

/**
 * 业务组件索引（与 Business 侧栏 / PageLayouts 对齐）
 * 可视化组件演示见 /business/visual-components（侧栏入口），不列入已完成页 Hub 的「业务组件」分类。
 * @typedef {{ id: string, title: string, path: string, subtitle?: string }} PreviewCatalogItem
 * @typedef {{ title: string, items: PreviewCatalogItem[] }} PreviewCatalogGroup
 */

/** @type {PreviewCatalogGroup[]} */
export const BUSINESS_CATALOG_GROUPS = [
  {
    title: '按功能场景',
    items: [
      { id: 'standard-dialogs', title: '标准弹窗', path: '/business/standard-dialogs' },
      { id: 'standard-navigation', title: '标准导航', path: '/business/standard-navigation' },
      { id: 'page-layouts', title: '标准布局', path: '/business/page-layouts', subtitle: '布局索引' },
    ],
  },  {
    title: '标准布局 · 线框',
    items: PAGE_LAYOUT_PAGES.map((p) => ({
      id: `${p.slug}-wire`,
      title: p.title,
      path: p.pathWire,
      subtitle: '布局线框',
    })),
  },
  {
    title: '标准布局 · 实际页面',
    items: PAGE_LAYOUT_PAGES.map((p) => ({
      id: `${p.slug}-real`,
      title: p.title,
      path: p.pathReal,
      subtitle: '实际页面',
    })),
  },
];
